const NAMESPACE = 'DUCKS/BROWSER_META';

const CLEAR_BROWSER_META = `${NAMESPACE}/CLEAR_BROWSER_META`;
const FETCHING_BROWSER_META = `${NAMESPACE}/FETCHING_BROWSER_META`;
const SET_BROWSER_META = `${NAMESPACE}/SET_BROWSER_META`;
const SET_BROWSER_USER_AGENT = `${NAMESPACE}/SET_BROWSER_USER_AGENT`;

export {
    CLEAR_BROWSER_META,
    FETCHING_BROWSER_META,
    SET_BROWSER_META,
    SET_BROWSER_USER_AGENT,
};

export default NAMESPACE;
